__turbopack_context__.v({
  "benefitItem": "ContactSplitSection-module___GAwDq__benefitItem",
  "benefitText": "ContactSplitSection-module___GAwDq__benefitText",
  "benefitsList": "ContactSplitSection-module___GAwDq__benefitsList",
  "checkIcon": "ContactSplitSection-module___GAwDq__checkIcon",
  "container": "ContactSplitSection-module___GAwDq__container",
  "contextSide": "ContactSplitSection-module___GAwDq__contextSide",
  "description": "ContactSplitSection-module___GAwDq__description",
  "errorMessage": "ContactSplitSection-module___GAwDq__errorMessage",
  "eyebrow": "ContactSplitSection-module___GAwDq__eyebrow",
  "formSide": "ContactSplitSection-module___GAwDq__formSide",
  "inputGroup": "ContactSplitSection-module___GAwDq__inputGroup",
  "row": "ContactSplitSection-module___GAwDq__row",
  "section": "ContactSplitSection-module___GAwDq__section",
  "submitButton": "ContactSplitSection-module___GAwDq__submitButton",
  "successMessage": "ContactSplitSection-module___GAwDq__successMessage",
  "supportCard": "ContactSplitSection-module___GAwDq__supportCard",
  "supportIcon": "ContactSplitSection-module___GAwDq__supportIcon",
  "title": "ContactSplitSection-module___GAwDq__title",
});
